import { useEffect, useState } from "react";

import { getItemFromLocalStorage, setItemInLocalStorage } from "./localStorage";

export function useSessionStorage<T>(key: string, initialValue: T | (() => T)) {
  const isClient = typeof window !== "undefined";
  const [value, setValue] = useState<T>(() => {
    if (isClient && key) {
      try {
        const jsonValue = getItemFromLocalStorage(key);
        if (jsonValue != null && jsonValue !== undefined && jsonValue !== "undefined") {
          return jsonValue;
        }
      } catch (e) {
        console.warn("Error reading from sessionStorage:", e);
      }
    }
    return typeof initialValue === "function" ? (initialValue as () => T)() : initialValue;
  });

  const [storageError, setStorageError] = useState<string | null>(null);
  useEffect(() => {
    if (isClient && key) {
      try {
        setItemInLocalStorage(key, value);
        setStorageError(null);
      } catch (e) {
        if (e instanceof DOMException && (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED")) {
          console.warn("Storage quota exceeded for key:", key);
          setStorageError("Storage quota exceeded");
        } else {
          console.warn("Unexpected sessionStorage error:", e);
          setStorageError("Unexpected storage error");
        }
      }
    }
  }, [key, value, isClient]);

  useEffect(() => {}, [key, value]);

  return [value, setValue, storageError] as [typeof value, typeof setValue, string | null];
}
